import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getEventos,
  deleteEvento,
  changeStatusEvento,
} from "../../../../api/evento";
import { Button, Tooltip, Switch, FormControlLabel, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  canEditGestionModule,
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";
import FiltersCard from "../../../components/filters/Filter";
import { getNonEmpty } from "../../../../utils/helpers";

function getData(eventos) {
  let data = [];
  for (let i = 0; i < eventos.length; ++i) {
    const elem = {};
    elem.titulo = getNonEmpty(eventos[i].titulo);
    elem.ubicacion = eventos[i].ubicacion || "";
    elem.fechaIni = eventos[i].fechaIni;
    elem.fechaFin = eventos[i].fechaFin;
    elem.url = eventos[i].url || "";
    elem.createdAt = eventos[i].createdAt;
    elem.id = eventos[i]._id;
    elem.active = eventos[i].active;
    elem._id = eventos[i]._id;
    data = data.concat(elem);
  }
  return data;
}

// Custom formatter for event dates
function eventDateFormatter(cell) {
  if (!cell) return "";
  const date = new Date(cell);
  return date.toLocaleDateString();
}

// Custom formatter for date range
function dateRangeFormatter(cell, row) {
  const startDate = row.fechaIni
    ? new Date(row.fechaIni).toLocaleDateString()
    : "";
  const endDate = row.fechaFin
    ? new Date(row.fechaFin).toLocaleDateString()
    : "";

  if (startDate && endDate) {
    return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
  }
  return startDate || endDate || "";
}

const initialFilters = {
  active: false,
  fechaIniDesde: '',
  fechaIniHasta: '',
};

export default function EventosPage() {
  const [data, setData] = useState([]);
  const [eventoId, setEventoId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  // Cargar filtros desde localStorage al iniciar
  const [filterOptions, setFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem('eventosPageFilters');
    return savedFilters ? JSON.parse(savedFilters) : initialFilters;
  });
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem('eventosPage_searchText');
    return saved || '';
  });
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              // Guardar filtros actuales antes de navegar
              localStorage.setItem('eventosPageFilters', JSON.stringify(filterOptions));
              history.push("/edit-evento/" + cell);
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(canEditGestionModule(user?.role) && !isReadOnlyConsultor(user?.role)) && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setEventoId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setEventoId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "titulo", text: "Título", sort: true },
    { dataField: "ubicacion", text: "Ubicación", sort: true },
    {
      dataField: "fechaIni",
      text: "Fechas",
      sort: true,
      formatter: dateRangeFormatter,
    },
    { dataField: "url", text: "URL", sort: true },
    {
      dataField: "createdAt",
      text: "Creado",
      sort: true,
      formatter: dateFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getEventos();
        if (res.status === 200) {
          setData(res.data);
          // Aplicar filtros guardados si existen
          const savedFilters = localStorage.getItem('eventosPageFilters');
          if (savedFilters) {
            const savedFilterOptions = JSON.parse(savedFilters);
            setFilterOptions(savedFilterOptions);
            // Aplicar filtros automáticamente
            const filtered = res.data.filter((item) => {
              let filter = true;
              if (savedFilterOptions.active) filter = filter && item.active;
              if (savedFilterOptions.fechaIniDesde) {
                const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
                const fechaDesde = new Date(savedFilterOptions.fechaIniDesde);
                if (!fechaIni || fechaIni < fechaDesde) filter = false;
              }
              if (savedFilterOptions.fechaIniHasta) {
                const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
                const fechaHasta = new Date(savedFilterOptions.fechaIniHasta);
                fechaHasta.setHours(23, 59, 59, 999); // Incluir todo el día
                if (!fechaIni || fechaIni > fechaHasta) filter = false;
              }
              if (filter) return item;
              return false;
            });
            setFilteredData(filtered);
          } else {
            setFilteredData(res.data);
          }
          setRefresh(false);
        }
      } catch (error) {
        alertError({ error: error, customMessage: "Could not get eventos." });
        history.push("/dashboard");
      }
    };
    fetch();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    // Guardar filtros en localStorage
    localStorage.setItem('eventosPageFilters', JSON.stringify(filterOptions));
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filterOptions.fechaIniDesde) {
          const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
          const fechaDesde = new Date(filterOptions.fechaIniDesde);
          if (!fechaIni || fechaIni < fechaDesde) filter = false;
        }
        if (filterOptions.fechaIniHasta) {
          const fechaIni = item.fechaIni ? new Date(item.fechaIni) : null;
          const fechaHasta = new Date(filterOptions.fechaIniHasta);
          fechaHasta.setHours(23, 59, 59, 999); // Incluir todo el día
          if (!fechaIni || fechaIni > fechaHasta) filter = false;
        }
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText('');
    localStorage.removeItem('eventosPageFilters');
    localStorage.removeItem('eventosPage_searchText');
    localStorage.removeItem('eventosPage_currentPage');
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "5px 0 0 0" }}>
        {/* Primera fila: Filtros en grid organizado - alineados por abajo */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('eventosPage_searchText', value);
                } else {
                  localStorage.removeItem('eventosPage_searchText');
                }
              }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaIniDesde"
              label="Fecha Inicio Desde"
              type="date"
              value={filterOptions.fechaIniDesde || ''}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaIniDesde: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaIniHasta"
              label="Fecha Inicio Hasta"
              type="date"
              value={filterOptions.fechaIniHasta || ''}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaIniHasta: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de eventos">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-evento")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody style={{ paddingTop: "15px" }}>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refresh && (
            <Table 
              data={getData(filteredData)} 
              columns={columns} 
              pageKey="eventosPage"
              searchText={searchText}
              onSearchChange={(value) => {
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('eventosPage_searchText', value);
                } else {
                  localStorage.removeItem('eventosPage_searchText');
                }
              }}
            />
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              eventoId?.active ? "disable" : "enable"
            } this evento?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusEvento(eventoId._id, !eventoId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${eventoId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Evento ${
                        eventoId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      eventoId?.active ? "disable" : "enable"
                    } evento.`,
                  });
                });
            }}
          />

          <ConfirmDialog
            title={"Are you sure you want to remove this evento?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteEvento(eventoId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Evento removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove evento.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
